import { createQueryKeys } from '@lukemorales/query-key-factory';

import { fetchInvitation } from '../api/invitation.api';

export const invitationQueryKeys = createQueryKeys('invitations', {
  fetchInvitationByUserId: () => ({
    queryFn: () => fetchInvitation(),
    queryKey: ['user-invitation'],
  }),
});
